import { Component, Input, OnInit } from '@angular/core';
import { DescendientesRecord } from '../../models/physical-record';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-physical-lower-level-table',
  templateUrl: './physical-lower-level-table.component.html',
  styleUrls: ['./physical-lower-level-table.component.scss']
})
export class PhysicalLowerLevelTableComponent implements OnInit {
  private static readonly MAX_DESKTOP_ITEMS = 10;
  private static readonly MAX_MOBILE_ITEMS = 4;

  private currentPaginationPage = 0;

  pageSize = PhysicalLowerLevelTableComponent.MAX_DESKTOP_ITEMS;
  isAllItemsDialogOpened = false;
  physicalLowerLevelItemsDisplay: DescendientesRecord[] = [];

  @Input() physicalLowerLevelItems: DescendientesRecord[] = [];

  constructor(private readonly breakpointObserver: BreakpointObserver,) { }

  ngOnInit(): void {
    this.breakpointObserver.observe('(max-width: 1199px)').subscribe((breakpoint) => {
      // Mobile
      if (breakpoint.matches) {
        this.pageSize = PhysicalLowerLevelTableComponent.MAX_MOBILE_ITEMS;
      } else { // Desktop
        this.pageSize = PhysicalLowerLevelTableComponent.MAX_DESKTOP_ITEMS;
      }

      this.paginate();
    });
  }

  physicalPage(pagination: any) {
    this.currentPaginationPage = pagination?.pageIndex * pagination.pageSize;
    this.paginate();
  }

  private paginate() {
    this.physicalLowerLevelItemsDisplay = this.physicalLowerLevelItems.slice(this.currentPaginationPage, this.currentPaginationPage + this.pageSize);
  }
}
